<template>
<nav class="pagination-nav">

<ul class="page-numbers">
    <li v-if="pages.current != 1">
        <button @click="emitSelection(pages.current - 1)" aria-label="previous page" class="prev page-numbers appearance-none"><i class="far fa-chevron-double-left" aria-hidden="true"></i></button>
    </li>
    <li v-for="page in pages.total">
        <button v-if="page != pages.current" @click="emitSelection(page)" class="page-numbers appearance-none">{{ page }}</button>
        <span v-else aria-current="page" class="page-numbers current">{{ page }}</span>
    </li>

    <li v-if="pages.current != pages.total"><button aria-label="next page" @click="emitSelection(pages.current + 1)" class="next page-numbers appearance-none"><i class="far fa-chevron-double-right" aria-hidden="true"></i></button></li>
</ul>

</nav>
</template>

<script>

export default {

    emits: ['selection'],
    props: ['pages'],
    
    setup(props, {emit}) {
        const emitSelection = (page) => {
            emit('selection', page);
        };
        return {
            emitSelection
        };
    }

}
</script>